import { render, staticRenderFns } from "./LegalMentions4xCb.vue?vue&type=template&id=43d61d1e"
import script from "./LegalMentions4xCb.vue?vue&type=script&lang=js"
export * from "./LegalMentions4xCb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports